var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticStyle:{"color":"white","text-align":"left"}},[_vm._v("Commentaires")]),_c('historic-comments-lift'),_c('h1',{staticStyle:{"color":"white","text-align":"left"}},[_vm._v("Pannes / Arrêts")]),_c('historic-breakdowns-lift')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }